// Statische Branchen-Zuordnung für alle kuratierten Aktien
// Fallback wenn Yahoo Finance keine summaryProfile-Daten liefert

const SECTOR_MAP = {
  // ── US Mega Cap ──────────────────────────────────────────────────────────────
  'AAPL':   { sector: 'Technology',               industry: 'Consumer Electronics' },
  'MSFT':   { sector: 'Technology',               industry: 'Software' },
  'NVDA':   { sector: 'Technology',               industry: 'Semiconductors' },
  'GOOGL':  { sector: 'Communication Services',   industry: 'Internet Content' },
  'GOOG':   { sector: 'Communication Services',   industry: 'Internet Content' },
  'AMZN':   { sector: 'Consumer Discretionary',   industry: 'Internet Retail' },
  'META':   { sector: 'Communication Services',   industry: 'Social Media' },
  'TSLA':   { sector: 'Consumer Discretionary',   industry: 'Electric Vehicles' },
  'AVGO':   { sector: 'Technology',               industry: 'Semiconductors' },

  // ── US Tech ──────────────────────────────────────────────────────────────────
  'NFLX':   { sector: 'Communication Services',   industry: 'Streaming' },
  'AMD':    { sector: 'Technology',               industry: 'Semiconductors' },
  'INTC':   { sector: 'Technology',               industry: 'Semiconductors' },
  'QCOM':   { sector: 'Technology',               industry: 'Semiconductors' },
  'ORCL':   { sector: 'Technology',               industry: 'Enterprise Software' },
  'CRM':    { sector: 'Technology',               industry: 'Cloud Software' },
  'ADBE':   { sector: 'Technology',               industry: 'Software' },
  'INTU':   { sector: 'Technology',               industry: 'Financial Software' },
  'NOW':    { sector: 'Technology',               industry: 'Cloud Software' },
  'PANW':   { sector: 'Technology',               industry: 'Cybersecurity' },
  'CRWD':   { sector: 'Technology',               industry: 'Cybersecurity' },
  'PLTR':   { sector: 'Technology',               industry: 'Data Analytics' },
  'SNOW':   { sector: 'Technology',               industry: 'Cloud Data' },
  'DDOG':   { sector: 'Technology',               industry: 'Cloud Monitoring' },
  'FTNT':   { sector: 'Technology',               industry: 'Cybersecurity' },
  'ZS':     { sector: 'Technology',               industry: 'Cybersecurity' },
  'AMAT':   { sector: 'Technology',               industry: 'Semiconductor Equipment' },
  'LRCX':   { sector: 'Technology',               industry: 'Semiconductor Equipment' },
  'MU':     { sector: 'Technology',               industry: 'Semiconductors' },
  'TXN':    { sector: 'Technology',               industry: 'Semiconductors' },
  'IBM':    { sector: 'Technology',               industry: 'IT Services' },
  'CSCO':   { sector: 'Technology',               industry: 'Networking' },
  'UBER':   { sector: 'Technology',               industry: 'Ride Sharing' },
  'SHOP':   { sector: 'Technology',               industry: 'E-Commerce' },
  'PYPL':   { sector: 'Financial Services',        industry: 'Payment Processing' },
  'TTD':    { sector: 'Technology',               industry: 'Digital Advertising' },
  'COIN':   { sector: 'Financial Services',        industry: 'Crypto Exchange' },
  'APP':    { sector: 'Technology',               industry: 'Mobile Software' },
  'SMCI':   { sector: 'Technology',               industry: 'Computer Hardware' },

  // ── US Finance ───────────────────────────────────────────────────────────────
  'JPM':    { sector: 'Financial Services',        industry: 'Banks' },
  'BAC':    { sector: 'Financial Services',        industry: 'Banks' },
  'GS':     { sector: 'Financial Services',        industry: 'Investment Banking' },
  'MS':     { sector: 'Financial Services',        industry: 'Investment Banking' },
  'WFC':    { sector: 'Financial Services',        industry: 'Banks' },
  'V':      { sector: 'Financial Services',        industry: 'Payment Processing' },
  'MA':     { sector: 'Financial Services',        industry: 'Payment Processing' },
  'AXP':    { sector: 'Financial Services',        industry: 'Credit Services' },
  'BRK-B':  { sector: 'Financial Services',        industry: 'Insurance & Holding' },
  'BLK':    { sector: 'Financial Services',        industry: 'Asset Management' },
  'SCHW':   { sector: 'Financial Services',        industry: 'Brokerage' },
  'COF':    { sector: 'Financial Services',        industry: 'Credit Services' },
  'SPGI':   { sector: 'Financial Services',        industry: 'Financial Data' },
  'MCO':    { sector: 'Financial Services',        industry: 'Credit Ratings' },
  'BX':     { sector: 'Financial Services',        industry: 'Private Equity' },
  'KKR':    { sector: 'Financial Services',        industry: 'Private Equity' },

  // ── US Healthcare ────────────────────────────────────────────────────────────
  'LLY':    { sector: 'Healthcare',               industry: 'Pharmaceuticals' },
  'JNJ':    { sector: 'Healthcare',               industry: 'Pharmaceuticals' },
  'ABBV':   { sector: 'Healthcare',               industry: 'Biotechnology' },
  'UNH':    { sector: 'Healthcare',               industry: 'Health Insurance' },
  'AMGN':   { sector: 'Healthcare',               industry: 'Biotechnology' },
  'MRK':    { sector: 'Healthcare',               industry: 'Pharmaceuticals' },
  'PFE':    { sector: 'Healthcare',               industry: 'Pharmaceuticals' },
  'MRNA':   { sector: 'Healthcare',               industry: 'Biotechnology' },
  'GILD':   { sector: 'Healthcare',               industry: 'Biotechnology' },
  'VRTX':   { sector: 'Healthcare',               industry: 'Biotechnology' },
  'REGN':   { sector: 'Healthcare',               industry: 'Biotechnology' },
  'BMY':    { sector: 'Healthcare',               industry: 'Pharmaceuticals' },
  'ISRG':   { sector: 'Healthcare',               industry: 'Medical Devices' },
  'TMO':    { sector: 'Healthcare',               industry: 'Life Sciences' },
  'ABT':    { sector: 'Healthcare',               industry: 'Medical Devices' },
  'MDT':    { sector: 'Healthcare',               industry: 'Medical Devices' },

  // ── US Consumer ──────────────────────────────────────────────────────────────
  'HD':     { sector: 'Consumer Discretionary',   industry: 'Home Improvement' },
  'MCD':    { sector: 'Consumer Discretionary',   industry: 'Restaurants' },
  'NKE':    { sector: 'Consumer Discretionary',   industry: 'Sportswear' },
  'SBUX':   { sector: 'Consumer Discretionary',   industry: 'Coffee & Cafés' },
  'TJX':    { sector: 'Consumer Discretionary',   industry: 'Discount Retail' },
  'LOW':    { sector: 'Consumer Discretionary',   industry: 'Home Improvement' },
  'BKNG':   { sector: 'Consumer Discretionary',   industry: 'Online Travel' },
  'CMG':    { sector: 'Consumer Discretionary',   industry: 'Restaurants' },
  'ABNB':   { sector: 'Consumer Discretionary',   industry: 'Online Travel' },
  'DIS':    { sector: 'Communication Services',   industry: 'Entertainment' },
  'LULU':   { sector: 'Consumer Discretionary',   industry: 'Apparel' },
  'TSCO':   { sector: 'Consumer Discretionary',   industry: 'Specialty Retail' },
  'EBAY':   { sector: 'Consumer Discretionary',   industry: 'E-Commerce' },
  'YUM':    { sector: 'Consumer Discretionary',   industry: 'Restaurants' },
  'DECK':   { sector: 'Consumer Discretionary',   industry: 'Footwear' },

  // ── US Staples ───────────────────────────────────────────────────────────────
  'WMT':    { sector: 'Consumer Staples',         industry: 'Retail' },
  'KO':     { sector: 'Consumer Staples',         industry: 'Beverages' },
  'PG':     { sector: 'Consumer Staples',         industry: 'Household Products' },
  'PEP':    { sector: 'Consumer Staples',         industry: 'Beverages' },
  'COST':   { sector: 'Consumer Staples',         industry: 'Retail' },
  'PM':     { sector: 'Consumer Staples',         industry: 'Tobacco' },
  'CL':     { sector: 'Consumer Staples',         industry: 'Household Products' },
  'MDLZ':   { sector: 'Consumer Staples',         industry: 'Food' },
  'TGT':    { sector: 'Consumer Staples',         industry: 'Retail' },
  'MO':     { sector: 'Consumer Staples',         industry: 'Tobacco' },

  // ── US Energie ───────────────────────────────────────────────────────────────
  'XOM':    { sector: 'Energy',                   industry: 'Oil & Gas' },
  'CVX':    { sector: 'Energy',                   industry: 'Oil & Gas' },
  'COP':    { sector: 'Energy',                   industry: 'Oil & Gas' },
  'SLB':    { sector: 'Energy',                   industry: 'Oil Services' },
  'OXY':    { sector: 'Energy',                   industry: 'Oil & Gas' },
  'EOG':    { sector: 'Energy',                   industry: 'Oil & Gas' },

  // ── US Industrials ───────────────────────────────────────────────────────────
  'GE':     { sector: 'Industrials',              industry: 'Aerospace' },
  'CAT':    { sector: 'Industrials',              industry: 'Heavy Machinery' },
  'RTX':    { sector: 'Industrials',              industry: 'Aerospace & Defense' },
  'DE':     { sector: 'Industrials',              industry: 'Agricultural Machinery' },
  'BA':     { sector: 'Industrials',              industry: 'Aerospace & Defense' },
  'HON':    { sector: 'Industrials',              industry: 'Conglomerate' },
  'ETN':    { sector: 'Industrials',              industry: 'Electrical Equipment' },
  'LMT':    { sector: 'Industrials',              industry: 'Aerospace & Defense' },
  'GD':     { sector: 'Industrials',              industry: 'Aerospace & Defense' },
  'NOC':    { sector: 'Industrials',              industry: 'Aerospace & Defense' },
  'UPS':    { sector: 'Industrials',              industry: 'Logistics' },
  'UNP':    { sector: 'Industrials',              industry: 'Rail Transport' },
  'MMM':    { sector: 'Industrials',              industry: 'Conglomerate' },
  'ADP':    { sector: 'Technology',               industry: 'HR Software' },
  'CTAS':   { sector: 'Industrials',              industry: 'Business Services' },

  // ── US Kommunikation ─────────────────────────────────────────────────────────
  'TMUS':   { sector: 'Communication Services',   industry: 'Telecom' },
  'VZ':     { sector: 'Communication Services',   industry: 'Telecom' },
  'T':      { sector: 'Communication Services',   industry: 'Telecom' },
  'CMCSA':  { sector: 'Communication Services',   industry: 'Media & Cable' },
  'EA':     { sector: 'Communication Services',   industry: 'Video Games' },
  'TTWO':   { sector: 'Communication Services',   industry: 'Video Games' },

  // ── Deutschland – DAX 40 ────────────────────────────────────────────────────
  'SIE.DE':   { sector: 'Industrials',            industry: 'Conglomerate' },
  'ALV.DE':   { sector: 'Financial Services',     industry: 'Versicherung' },
  'DTE.DE':   { sector: 'Kommunikation',          industry: 'Telekommunikation' },
  'MUV2.DE':  { sector: 'Financial Services',     industry: 'Rückversicherung' },
  'MBG.DE':   { sector: 'Consumer Discretionary', industry: 'Automobile' },
  'BMW.DE':   { sector: 'Consumer Discretionary', industry: 'Automobile' },
  'BAYN.DE':  { sector: 'Healthcare',             industry: 'Pharmazeutik' },
  'BAS.DE':   { sector: 'Materials',              industry: 'Chemie' },
  'ADS.DE':   { sector: 'Consumer Discretionary', industry: 'Sportartikel' },
  'DBK.DE':   { sector: 'Financial Services',     industry: 'Banken' },
  'IFX.DE':   { sector: 'Technology',             industry: 'Halbleiter' },
  'RWE.DE':   { sector: 'Utilities',              industry: 'Erneuerbare Energie' },
  'VOW3.DE':  { sector: 'Consumer Discretionary', industry: 'Automobile' },
  'P911.DE':  { sector: 'Consumer Discretionary', industry: 'Sportwagen' },
  'SHL.DE':   { sector: 'Healthcare',             industry: 'Medizintechnik' },
  'ENR.DE':   { sector: 'Utilities',              industry: 'Energie' },
  'HEI.DE':   { sector: 'Materials',              industry: 'Baustoffe' },
  'MTX.DE':   { sector: 'Industrials',            industry: 'Luftfahrtantriebe' },
  'RHM.DE':   { sector: 'Industrials',            industry: 'Rüstung' },
  'DHL.DE':   { sector: 'Industrials',            industry: 'Logistik' },
  'EOAN.DE':  { sector: 'Utilities',              industry: 'Energieversorger' },
  'FRE.DE':   { sector: 'Healthcare',             industry: 'Gesundheitsdienstleist.' },
  'FME.DE':   { sector: 'Healthcare',             industry: 'Dialyse' },
  'ZAL.DE':   { sector: 'Consumer Discretionary', industry: 'Mode E-Commerce' },
  'VNA.DE':   { sector: 'Real Estate',            industry: 'Wohnimmobilien' },
  'HNR1.DE':  { sector: 'Financial Services',     industry: 'Rückversicherung' },
  'MRK.DE':   { sector: 'Healthcare',             industry: 'Pharmazeutik & Chemie' },
  'CON.DE':   { sector: 'Consumer Discretionary', industry: 'Autozulieferer' },
  'BEI.DE':   { sector: 'Consumer Staples',       industry: 'Kosmetik & Pflege' },
  'AIR.DE':   { sector: 'Industrials',            industry: 'Luft- & Raumfahrt' },
  'CBK.DE':   { sector: 'Financial Services',     industry: 'Banken' },
  'DTG.DE':   { sector: 'Industrials',            industry: 'Nutzfahrzeuge' },
  'DB1.DE':   { sector: 'Financial Services',     industry: 'Börsenbetreiber' },
  'HEN3.DE':  { sector: 'Consumer Staples',       industry: 'Haushalt & Pflege' },
  'BNR.DE':   { sector: 'Materials',              industry: 'Chemiedistribution' },
  'SY1.DE':   { sector: 'Consumer Staples',       industry: 'Aromen & Düfte' },
  'QGEN.DE':  { sector: 'Healthcare',             industry: 'Diagnostik' },
  'G24.DE':   { sector: 'Technology',             industry: 'Online-Marktplatz' },
  'PAH3.DE':  { sector: 'Financial Services',     industry: 'Automobilholding' },

  // ── Deutschland – MDAX / TecDAX ──────────────────────────────────────────────
  'LHA.DE':   { sector: 'Industrials',            industry: 'Luftfahrt' },
  'PUM.DE':   { sector: 'Consumer Discretionary', industry: 'Sportartikel' },
  'DHER.DE':  { sector: 'Consumer Discretionary', industry: 'Essenslieferung' },
  'SRT3.DE':  { sector: 'Healthcare',             industry: 'Laborausrüstung' },
  'NEM.DE':   { sector: 'Technology',             industry: 'Bausoftware' },
  'AIXA.DE':  { sector: 'Technology',             industry: 'Halbleiterequipment' },
  'EVT.DE':   { sector: 'Healthcare',             industry: 'Biotechnologie' },
  'AFX.DE':   { sector: 'Healthcare',             industry: 'Medizintechnik' },
  'EVD.DE':   { sector: 'Communication Services', industry: 'Live-Entertainment' },
  'FRA.DE':   { sector: 'Industrials',            industry: 'Flughafenbetrieb' },
  'HFG.DE':   { sector: 'Consumer Staples',       industry: 'Kochboxen' },
  'BC8.DE':   { sector: 'Technology',             industry: 'IT-Dienstleistungen' },
  'LEG.DE':   { sector: 'Real Estate',            industry: 'Wohnimmobilien' },
  'BOSS.DE':  { sector: 'Consumer Discretionary', industry: 'Mode & Lifestyle' },
  'UTDI.DE':  { sector: 'Communication Services', industry: 'Telekommunikation' },
  'TKA.DE':   { sector: 'Industrials',            industry: 'Stahl & Engineering' },
  'NDX1.DE':  { sector: 'Industrials',            industry: 'Windenergie' },
  'SHA.DE':   { sector: 'Consumer Discretionary', industry: 'Autozulieferer' },
  'JEN.DE':   { sector: 'Technology',             industry: 'Photonik' },
  'WAF.DE':   { sector: 'Technology',             industry: 'Halbleiter' },

  // ── Europa ───────────────────────────────────────────────────────────────────
  'ASML.AS':  { sector: 'Technology',             industry: 'Semiconductor Equipment' },
  'SHELL.AS': { sector: 'Energy',                 industry: 'Oil & Gas' },
  'MC.PA':    { sector: 'Consumer Discretionary', industry: 'Luxusgüter' },
  'OR.PA':    { sector: 'Consumer Staples',       industry: 'Kosmetik' },
  'AIR.PA':   { sector: 'Industrials',            industry: 'Luft- & Raumfahrt' },
  'TTE.PA':   { sector: 'Energy',                 industry: 'Oil & Gas' },
  'SAN.PA':   { sector: 'Healthcare',             industry: 'Pharmazeutik' },
  'BNP.PA':   { sector: 'Financial Services',     industry: 'Banken' },
  'NESN.SW':  { sector: 'Consumer Staples',       industry: 'Lebensmittel & Getränke' },
  'NOVN.SW':  { sector: 'Healthcare',             industry: 'Pharmazeutik' },
  'ROG.SW':   { sector: 'Healthcare',             industry: 'Pharmazeutik & Diagnostik' },

  // ── Japan ────────────────────────────────────────────────────────────────────
  'TM':       { sector: 'Consumer Discretionary', industry: 'Automobile' },
  'HMC':      { sector: 'Consumer Discretionary', industry: 'Automobile' },
  'NTDOY':    { sector: 'Communication Services', industry: 'Video Games' },
  'SONY':     { sector: 'Technology',             industry: 'Elektronik & Entertainment' },

  // ── Sonstige ─────────────────────────────────────────────────────────────────
  'BABA':     { sector: 'Consumer Discretionary', industry: 'E-Commerce' },
  'TSM':      { sector: 'Technology',             industry: 'Semiconductors' },
  'NVO':      { sector: 'Healthcare',             industry: 'Pharmaceuticals' },
  'ASML':     { sector: 'Technology',             industry: 'Semiconductor Equipment' },
  'SAP':      { sector: 'Technology',             industry: 'Enterprise Software' },
};

export default SECTOR_MAP;
